export default "__VITE_ASSET__DhHYKfdO__"